"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AccountCard = /** @class */ (function (_super) {
    __extends(AccountCard, _super);
    function AccountCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountCard.prototype.render = function () {
        var _a = this.props, title = _a.title, children = _a.children, link = _a.link;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "flex justify-between items-center mb-1" },
                React.createElement("h3", { className: "text-xmd leading-normal font-sans font-semibold text-navy-dark" }, title),
                link ? (React.createElement("a", { className: "flex items-center justify-end text-charcoal transition-fast hover:text-midnight text-xs leading-normal", href: link.url }, link.title)) : null),
            children));
    };
    return AccountCard;
}(React.PureComponent));
exports.AccountCard = AccountCard;
